// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"118": "lib-router","72": "lib-axios",}[chunkId] || chunkId) + "." + {"118": "a68e079e","366": "c7d8f862","503": "daf4ebc0","72": "ca34d5ce","746": "eb38100d","774": "8bf8e8df","834": "694cbf4e",}[chunkId] + ".js"
}